import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/analytics'
import 'firebase/functions'

/* Load the firebase configuration from process environment */
const env = process.env.REACT_APP_ENV
const firebaseConfig = {
    apiKey: process.env[`REACT_APP_FIREBASE_API_KEY_${env}`],
    authDomain: process.env[`REACT_APP_AUTH_DOMAIN_${env}`],
    databaseURL: process.env[`REACT_APP_DATABASE_URL_${env}`],
    projectId: process.env[`REACT_APP_PROJECTID_${env}`],
    storageBucket: process.env[`REACT_APP_STORAGE_BUCKET_${env}`],
    messagingSenderId: process.env[`REACT_APP_MESSAGING_SENDER_ID_${env}`],
    appId: process.env[`REACT_APP_APP_ID_${env}`],
    measurementId: process.env[`REACT_APP_MEASUREMENTID_${env}`] || null,
}

/* Instantiate firebase */
const firebaseDB = firebase.initializeApp(firebaseConfig)

if (firebaseConfig.measurementId !== null) {
    firebase.analytics()
}

export const googleProvider = new firebase.auth.GoogleAuthProvider()
export const facebookProvider = new firebase.auth.FacebookAuthProvider()

// if (window.location.hostname === 'localhost') {
//     firebase.functions().useFunctionsEmulator('http://localhost:5001')
// }

/* Export firebase */
export default firebaseDB
